export default __webpack_public_path__ + "static/logo-805592212e2703f0a06eaba14c0377f1.png";